import { createPlugin } from '@worldmanuals/sp-sampling'

export default {
  install (Vue, options) {
    const enabled = process.env.NODE_ENV === 'production'
    const Sampling = createPlugin({ enabled, ...options })
    Vue.use(Sampling)
  },
}
